import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, HttpModule, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { State } from '../../model/state.model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { stateURL } from '../../../shared/apiUrlConfig';
import { UserFriendlyMsgs } from '../../app.user-msgs';
import { configURI } from '../../../shared/apiUrlConfig';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Injectable()

export class StatesService {
    agentId: any;
    url = environment.configURI;
    constructor(public httpClient: HttpClient, private http: Http , private userFriendlyMsgs: UserFriendlyMsgs) { }
    
    getStates():any {
        return this.httpClient.get(environment.stateURL).catch(this.userFriendlyMsgs.errorHandler);
    }

    getStatesByMasterVendorId(vendorId):any {
        return this.httpClient.get(this.url + '/vendors/' + vendorId + '/states').catch(this.userFriendlyMsgs.errorHandler);
    }

    private handleError (error: Response | any) {
        //this.httpHeaderOptions.headers.set('x-access-token', localStorage.getItem('Token'));
        
        return Observable.throw(error);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/states/states.service.ts